import React, { useState, useEffect } from 'react';
import cls from './information.module.scss';
import { Col, Form, Row } from 'react-bootstrap';
import { Icon, Button } from 'lb-components';
import { PromoIcon } from '../../../../assets/icons/menu';
import UserVerificationIcon from '../../UserVerificationIcon/UserVerificationIcon';
import { Api, Toast, useTranslation } from 'lb-store';
import {UseOTP, UsePhoneVerification, UseAlert, UseUser} from 'lb-store/src/hooks';

const UserInformation = ({ route, setRoute, navigate, t }) => {
  const [userInfo, setUserInfo] = useState();
  const [updateMobile, setUpdateMobile] = useState(false);
  const otp = UseOTP();
  const phoneVerification = UsePhoneVerification();
  const alert = UseAlert();

  useEffect(() => {
    getData()
  }, []);


  const getData = () =>{
    Api.User.Info().then((res) => {
      if (res.status && res.data?.status === 1) {
        setUserInfo(res.data.data);
      }
    });
  }
  const changeMobileHandler = () => {

    if(userInfo?.mobileVerified===0){
      setUpdateMobile(true);
      return;
    }

    Api.User.UpdateMobile({}).then((res) => {
      if (res.status && res.data?.status === 1) {
        otp.open({
          onSuccess: (code, callback, close) => {
            Api.User.UpdateMobile({ smsCode: code }).then((res) => {
              if (res.status && res.data?.status === 1) {
                close();
                setUpdateMobile(true);
              } else {
                //callback(res.data?.error);
                callback(t('შეცდომა! შეიყვანეთ სწორი SMS კოდი'));
              }
            });
          },
          onResend: (callback) => {
            Api.User.UpdateMobile({}).then((res) => {
              callback(res.data?.left, res.data?.desc);
            });
          },
        });
      }
    });
  };
  const newMobileHandler = () => {
    //e.preventDefault();
    const value = document.getElementById('mobile').value;
    Api.User.UpdateMobile({ mobile: value }).then((res) => {
      if (res.status && res.data?.status === 1) {
        otp.open({
          onSuccess: (code, callback, close) => {
            Api.User.UpdateMobile({ smsCode: code }).then((res) => {
              if (res.status && res.data?.status === 1) {
                close();
                setUpdateMobile(false);
                Toast.show({
                  content: t('მობილურის ნომერი წარმატებით შეიცვალა'),
                });

                getData()
              } else {
                //callback(res.data?.error);
                callback(t('შეცდომა! შეიყვანეთ სწორი SMS კოდი'));
              }
            });
          },
          onResend: (callback) => {
            Api.User.UpdateMobile({}).then((res) => {
              callback(res.data?.left, res.data?.desc);
            });
          },
        });
      } else {
        Toast.show({ type: 'error', content: res.data?.desc });
      }
    });
  };
  const BlockAccount=({cancel, setState,state,exit})=>{
    //const {logout} = UseUser();
    const chosePeriod = (period) => {
      console.log(state)
      setState({
        ...state,
        show:false,
        period: period,

      })
    }

    const onAccept=(method = '')=>{
      //console.log('state',state)
      if(method === 'close'){
        document.querySelector(".modal").remove()
        document.querySelector(".modal-backdrop").remove()
        state?.status && !state?.otp && exit()
        return
      }
      Api.User.DisableAccount(method==='resend'? {period:state.period,}:{period:state.period, code:state.code}).then((res)=>{
        if(res?.data?.code==="sms"){
          setState({
            ...state,
            otp:true,
            desc: res?.data?.status === 1? res?.data?.desc : res?.data?.error,
            status:res?.data?.status
          })
        }else {
          if(res?.data?.status===1){
            setState({
              ...state,
              otp:false,
              status:res?.data?.status,
              code: null,
              success:'ok'
            })
          }
        }
      })


    }
    return (
        <div className={cls.disable_account_wrap}>

          <div className={cls.disable_account}>
            {
                !state?.otp && !state?.status && (
                    <>
                      <h3>{t('ანგარიშის დაბლოკვა')}</h3>
                      <p>{t('აირჩიეთ რა პერიოდით გსურთ ანგარიშის დაბლოკვა:')}</p>
                      <div className={cls.select} onClick={() => {
                        if (state == null) {
                          setState({
                            period: null,
                            show: true,
                            otp: false,
                            code: null
                          })
                        } else {
                          setState({
                            ...state,
                            show: true
                          })
                        }
                      }}>
                        <div className={cls.current}>
                          <span>{state?.period ? state?.period + " "+t('დღე') : t("აირჩიეთ დრო")}</span></div>
                        {
                            state?.show && <ul>
                              <li onClick={(e) => {
                                e.stopPropagation();
                                chosePeriod('1')
                              }}>1 {t('დღე')}
                              </li>
                              <li onClick={(e) => {
                                e.stopPropagation();
                                chosePeriod('2')
                              }}>2 {t('დღე')}
                              </li>
                              <li onClick={(e) => {
                                e.stopPropagation();
                                chosePeriod('3')
                              }}>3 {t('დღე')}
                              </li>
                            </ul>
                        }
                      </div>
                    </>
                )
            }


            {
                state?.otp && (
                    <>
                      <h3>{t('ერთჯერადი SMS კოდის შემოწმება')}</h3>
                      <p className={cls.tur_text} dangerouslySetInnerHTML={{__html: state?.desc}}/>
                      <input className={cls.otp} id="code_id" type="text" placeholder={t('sms საკოდი')} data-status={state?.status}
                             onChange={(e) => setState({...state, code: e.target.value})}/>
                      <div className={cls.sms_modal_action} data-status={state?.status}>
                                <span data-status={state?.status}
                                      onClick={()=> {
                                        document.getElementById('code_id').value = ''
                                        onAccept('resend')
                                      }}
                                >{t('თავიდან გაგზავნა')}</span>
                        <span data-status={state?.status}>{t('შეცდომა! შეიყვანეთ სწორი SMS კოდი')}</span>
                      </div>
                    </>
                )
            }

            {
                state?.status && !state?.otp && (
                    <div className={cls.success_mod}>
                      {/*<img src={SuccessIconFill} alt=""/>*/}
                      <p>{t('თქვენი ანგარიში დაიბლოკა')}</p>
                    </div>
                )
            }

            <br/>
            <div className={cls.disable_account_btn}>
              <button className={cls.button_da} data-status={state?.success} onClick={() => onAccept() }>{t('დადასტურება')}</button>
              <button className={cls.button_co} onClick={()=>{onAccept('close')}}>{state?.status && !state?.otp ? t('დახურვა') : t('გაუქმება')}</button>
            </div>
          </div>
        </div>
    )
  }
  return (
      <div className={cls.promoPage}>
        <div className={cls.description}>
          <UserVerificationIcon
              style={{width: '10rem', height: '10rem'}}
              bulletStyle={{
                width: '2rem',
                height: '2rem',
                right: '0.8rem',
              }}
          />
        </div>
        <div className={cls.userInfo}>
          <Form className={cls.form}>
            <Form.Group>
              <Form.Label>{t('პინი')}</Form.Label>
              <Form.Control
                  type='text'
                  className={cls.input}
                  defaultValue={userInfo?.pin}
                  disabled
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{t('პირნომერი')}</Form.Label>
              <Form.Control
                  type='text'
                  className={cls.input}
                  defaultValue={userInfo?.personalId}
                  disabled
              />
            </Form.Group>
          </Form>
        </div>

        <div className={cls.userInput}>
          <Form className={cls.form} onSubmit={newMobileHandler}>
            <Row>
              <Col>
                <h3>{t('საკონტაქტო ინფორმაცია')}</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('მობილურის ნომერი')}</Form.Label>
                  <Form.Control
                      id={'mobile'}
                      type='text'
                      className={cls.input}
                      defaultValue={updateMobile ? '' : userInfo?.mobile}
                      disabled={!updateMobile}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              {!userInfo?.mobileVerified && (
                  <Col>
                    <Button
                        variant='success'
                        type='button'
                        className={cls.button}
                        onClick={() => {
                          phoneVerification.open({
                            onSuccess: () => {
                              alert.open({
                                message: t('თქვენი ნომერი ვერიფიცირებულია'),
                              });
                            },
                          });
                        }}
                    >
                      {t('ვერიფიკაცია')}
                    </Button>
                  </Col>
              )}

              <Col
                  style={{textAlign: userInfo?.mobileVerified ? 'start' : 'end'}}
              >
                <Button
                    variant='success'
                    className={cls.button}
                    onClick={() => !updateMobile ? changeMobileHandler() : newMobileHandler()}
                >
                  {updateMobile ? t('დასტური') : t('შეცვლა')}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
        <div className={cls.userInfoForm}>
          <Form className={cls.form}>
            <Row>
              <Col>
                <h3>{t('პერსონალური ინფორმაცია')}</h3>
              </Col>
            </Row>
            <Form.Group>
              <Form.Label>{t('სახელი')}</Form.Label>
              <Form.Control
                  type='text'
                  className={cls.input}
                  defaultValue={userInfo?.fname.concat(' ').concat(userInfo?.lname)}
                  disabled
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{t('ელფოსტა')}</Form.Label>
              <Form.Control
                  type='text'
                  className={cls.input}
                  defaultValue={userInfo?.email}
                  disabled
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{t('ტელეფონი')}</Form.Label>
              <Form.Control
                  type='text'
                  className={cls.input}
                  defaultValue={userInfo?.mobile}
                  disabled
              />
            </Form.Group>
          </Form>
        </div>

        <div className={cls.account_button}>
          <Button
              variant={'secondary'}
              onClick={() =>
                  alert.open({
                    footer: false,
                    containerStyle: cls.disable_account_content,
                    //footerComponent: ({cancel}) => (
                    //    <div className={classes.disable_account_btn}>
                    //        <button className={classes.button_da} onClick={() => cancel()}>
                    //            {t('დადასტურება')}
                    //        </button>
                    //    </div>
                    //),
                    bodyComponent: BlockAccount,
                    onCancel: (value) => {
                      console.log(value)
                    }
                  })}
          >
            {t('ანგარიშის დაბლოკვა')}
          </Button>
          <Button
              variant={'danger'}
              onClick={() => {
                alert.open({
                  containerStyle: cls.disable_account_content_mod2,
                  message: <div className={cls.disable_account_content_mod2_text}>{t('ანგარიშის გაუქმება ტექსტი')}</div>
                })
              }}
          >
            {t('ანგარიშის გაუქმება')}
          </Button>
        </div>

        <div className={cls.description}>
          {t(
              'მონაცემების შესაცვლელად საჭიროა გამოაგზავნოთ თქვენი პირადობის მოწმობის დასკანირებული ვერსია support@leader-bet.com ჩვენს საკონტაქტო ელ-ფოსტაზე და მიუთითეთ შესაცვლელი მონაცემები'
          )}
        </div>
      </div>
  );
};
export default UserInformation;
